<template>
  <g>
    <rect
      x="2"
      y="4"
      width="20"
      height="16"
      rx="1"
      :stroke="iconColor"
      stroke-width="2"
    />
    <path
      d="M2 6L11.4855 11.6913C11.8022 11.8813 12.1978 11.8813 12.5145 11.6913L22 6"
      :stroke="iconColor"
      stroke-width="2"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#3c3c3c"
    }
  }
};
</script>
